import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { confirmTabsWithContent, listTabsWithContentOnReduction } from "../utils/courseTabCountChange";

function CourseTabCountInput({
  tabCount,
  tabs,
  bloquesContenido,
  tests,
  disabled,
  title,
  onCommit,
}) {
  const [draft, setDraft] = useState(String(tabCount));
  const commitLockRef = useRef(false);
  const lastHandledDraftRef = useRef(null);

  useEffect(() => {
    setDraft(String(tabCount));
  }, [tabCount]);

  const applyDraft = () => {
    if (commitLockRef.current) {
      return;
    }

    const raw = draft;
    const cantidad = Number.parseInt(raw, 10);
    if (raw === "" || Number.isNaN(cantidad) || cantidad < 0) {
      setDraft(String(tabs.length));
      return;
    }
    if (cantidad === tabs.length || lastHandledDraftRef.current === raw) {
      return;
    }

    commitLockRef.current = true;
    try {
      if (cantidad < tabs.length) {
        const pending = listTabsWithContentOnReduction(tabs, cantidad, bloquesContenido, tests);
        const accepted = confirmTabsWithContent(pending, (message) => globalThis.confirm(message));
        if (!accepted) {
          lastHandledDraftRef.current = raw;
          setDraft(String(tabs.length));
          return;
        }
      }
      lastHandledDraftRef.current = raw;
      onCommit(cantidad);
    } finally {
      commitLockRef.current = false;
    }
  };

  return (
    <input
      type="number"
      min="0"
      className="numero-pestañas"
      aria-label="Número de pestañas del curso"
      onWheel={(event) => event.currentTarget.blur()}
      value={draft}
      disabled={disabled}
      title={title}
      onChange={(event) => {
        lastHandledDraftRef.current = null;
        setDraft(event.target.value);
      }}
      onBlur={applyDraft}
      onKeyDown={(event) => {
        if (event.key !== "Enter") {
          return;
        }
        event.preventDefault();
        applyDraft();
      }}
    />
  );
}

CourseTabCountInput.propTypes = {
  tabCount: PropTypes.number.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  bloquesContenido: PropTypes.objectOf(PropTypes.array),
  tests: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool,
  title: PropTypes.string,
  onCommit: PropTypes.func.isRequired,
};

CourseTabCountInput.defaultProps = {
  bloquesContenido: {},
  tests: [],
  disabled: false,
  title: undefined,
};

export default CourseTabCountInput;
